module.exports = __webpack_public_path__ + "src/assets/img/pic (4).08d7429d.jpg";